// extracted by mini-css-extract-plugin
export default {"root":"RefereeRequest_root__8ZwkL","title":"RefereeRequest_title__w8uDk"};